import uuid from "react-native-uuid";
import { deleteFromBlockMetadataMap } from "../utils/metalensUtils";

export default (
  state = {
    metadata: [],
    currentHash: "",
    previousHash: "",
    metadataReRenderId: "initial",
    active: false,
    metalensTutorialActive: false,
    lastActive: null,
    blockMetadataMap: null,
    // clauses
    departmentClauseMapping: null,
    fullAnalysis: null,
    blockSpotlightMap: null, // unused
    perDepartmentAnalysisIndex: null,
    perClauseAnalysisIndex: null,
    spotlightIndex: null,
    latestFeedback: null,
    updatedDocAnalysis: false,
    clauseDepartmentMapping: null,
    spotlightEntities: null,
    spotlightEntitiesActive: null,
    entityTypeInfo: null,
    isLatestAnalysis: true,
    quickReviewActive: false,
  },
  action,
) => {
  switch (action.type) {
    case "GET_DOC_METADATA":
      return {
        ...state,
        metadataReRenderId: uuid.v4(),
        metadata: action.payload.metadata,
        lastActive: action.payload.lastActive,
        blockMetadataMap: action.payload.blockMetadataMap,
        blockSpotlightMap: null,
        spotlightEntities: null,
        spotlightEntitiesActive: null,
      };

    case "UPDATE_DOC_SAVE_INDICATOR":
      return {
        ...state,
        currentHash: action.payload === "SAVED" ? "UPDATE" : state.currentHash,
        lastActive: action.payload.lastActive,
      };
    case "BATCH_UPDATE_SECTION_IN_DOCUMENT":
      return {
        ...state,
        currentHash: "UPDATE",
      };

    case "SET_COMMON_META_HASH":
      return {
        ...state,
        currentHash: "GET",
        previousHash: "GET",
      };

    case "SET_METALENS_STATUS":
      return {
        ...state,
        active: action.payload.active,
        metadata: action.payload.action ? state.metadata : [],
      };

    case "SET_METALENS_TUTORIAL_STATUS":
      return {
        ...state,
        metalensTutorialActive: action.payload.active,
      };

    case "ADD_NEW_DOC_METADATA":
      return {
        ...state,
        metadata: [...state.metadata, action.payload.newMetaData],
        lastActive: action.payload.lastActive,
      };

    case "UPDATE_DOC_METADATA":
      return {
        ...state,
        metadata: state.metadata.map(item => {
          if (item.id === action.payload.updatedMetaItem.id) {
            return action.payload.updatedMetaItem;
          }
          return item;
        }),
        lastActive: action.payload.lastActive,
      };

    case "DELETE_DOC_METADATA":
      return {
        ...state,
        metadata: state.metadata.filter(item => item.id !== action.payload.id),
        blockMetadataMap: deleteFromBlockMetadataMap(
          state.blockMetadataMap,
          action.payload.id,
        ),
        lastActive: action.payload.lastActive,
      };

    case "SUGGEST_TEMPLATE_FIELDS":
      return {
        ...state,
      };

    // clause analysis
    case "FETCH_DOC_ANALYSIS":
      return {
        ...state,
        fullAnalysis: action.payload.fullAnalysis,
        perDepartmentAnalysisIndex: action.payload.perDepartmentAnalysisIndex,
        perClauseAnalysisIndex: action.payload.perClauseAnalysisIndex,
        spotlightIndex: action.payload.spotlightIndex,
        updatedDocAnalysis: false,
        isLatestAnalysis: true,
        blockMetadataMap: null,
        blockSpotlightMap: action.payload.blockSpotlightMap,
      };

    case "DOC_ANALYSIS_PROVIDE_FEEDBACK":
      return {
        ...state,
        latestFeedback: action.payload,
      };

    case "UPDATE_DOC_ANALYSIS":
      return {
        ...state,
        updatedDocAnalysis: true,
        isLatestAnalysis: false,
      };

    case "FETCH_CLAUSE_ANALYSIS_META":
      return {
        ...state,
        clauseDepartmentMapping: action.payload.clauseDepartmentMapping,
        departmentClauseMapping: action.payload.departmentClauseMapping,
        entityTypeInfo: action.payload.entityTypeInfo,
      };

    case "REMOVE_QUICK_REVIEW_DATA":
      return {
        metadata: [],
        currentHash: "",
        previousHash: "",
        active: false,
        metalensTutorialActive: false,
        lastActive: null,
        // clauses
        fullAnalysis: null,
        perDepartmentAnalysisIndex: null,
        perClauseAnalysisIndex: null,
        latestFeedback: null,
        updatedDocAnalysis: false,
        spotlightIndex: null,
        spotlightEntities: null,
        spotlightEntitiesActive: false,
        isLatestAnalysis: true,
        blockMetadataMap: null,
        blockSpotlightMap: null,
      };

    case "HIGHLIGHT_SPOTLIGHT":
      return {
        ...state,
        spotlightEntities: action.payload.entities,
        spotlightEntitiesActive: action.payload.componentID,
      };

    case "REMOVE_HIGHLIGHT_SPOTLIGHT":
      return {
        ...state,
        spotlightEntities: null,
        spotlightEntitiesActive: null,
        blockSpotlightMap: null,
      };

    case "COPY_COMPONENTS_QUICKREVIEW":
      return {
        ...state,
        quickReviewActive: true,
      };

    case "REVERSE_UPDATE_COMPONENTS_QUICKREVIEW":
      return {
        ...state,
        quickReviewActive: false,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/MetalensReducer.js